<template>
  <div class="stats-grid">
    <div 
      v-for="n in count"
      :key="n"
      class="stat-card skeleton-card"
    >
      <div class="skeleton-value"></div>
      <div class="skeleton-label"></div>
    </div>
  </div>
</template>
<script setup>

const props = defineProps({
  count: {
    type: Number,
    default: 4
  }
})
</script>

<style scoped>
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-auto-rows: 1fr;
  gap: 16px;
  height: 100%;
}

.stat-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: var(--color-background);
  border: var(--border-card);
  border-radius: var(--border-radius-card);
  box-shadow: var(--shadow-card);
  padding: 20px;
  text-align: center;
}

.skeleton-card .skeleton-value,
.skeleton-card .skeleton-label {
  height: 16px;
  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
  margin: 8px auto;
}

.skeleton-card .skeleton-value {
  width: 50%;
  height: 32px;
  margin-bottom: 12px;
}

.skeleton-card .skeleton-label {
  width: 70%;
  height: 12px;
}

@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}
</style>
